/* globals App */

import axios from "axios";
import { Form } from "./form";
import { Security } from "./security";

export class LoginForm extends Form {
  init() {
    this.security = new Security();
    document.body.addEventListener("modals-ready", () => {
      this.twoFaModal = App.modals.getModal("twofa-modal");
      this.loader = this.twoFaModal.content.querySelector(".loader");
      this.initSelectOtherMethod();
      super.init();
    });
  }

  submit() {
    this.submitWrapper.classList.add(this.settings.submittingClass);
    this.disableSubmit();
    this.settings.onSubmit();
    this.clearErrors();
    this.beforeSubmit().then(
      () => {
        let data = this.getSubmitUrlAndData();
        axios
          .post(data.url, data.data, {
            headers: {
              Accept: "application/json",
            },
          })
          .then((response) => {
            let data = response.data;
            this.loginData = data;
            if (data.authMethod) {
              this.init2FaForm(data);
              this.afterSubmit();
              return;
            }
            this.onLoginSuccess();
          })
          .catch((error) => {
            let data = error.response ? error.response.data : {};
            this.showToast(this.settings.errorMessage || data.message, "error", false);
            this.addFormError(this.settings.errorMessage || data.message);
            this.addFormErrors(data.errors);
            this.resetRecaptcha();
            this.focusOnFirstError(data);
            this.settings.onFail(data);
            this.afterSubmit();
          });
      },
      () => {
        this.afterSubmit();
      },
    );
  }

  onLoginSuccess() {
    this.settings.onSuccess(this.loginData);
    let redirect = false;
    let store = false;
    if (this.settings.redirect) {
      if (this.loginData.redirect) {
        redirect = this.loginData.redirect;
        store = true;
      } else {
        throw new Error("Ajax call did not provide a redirect url");
      }
    }
    this.showToast(
      this.settings.successMessage ? this.settings.successMessage : this.loginData.message || "Success",
      "success",
      store,
    );
    if (redirect) {
      window.location.href = redirect;
      return;
    }
    this.showSuccessBlock();
    this.afterSubmit();
  }

  init2FaForm(data) {
    let content = this.twoFaModal.content.querySelector(".twofa-content");
    content.innerHTML = data.authForm;
    switch (data.authMethod) {
      case "craft\\auth\\methods\\TOTP":
        this.security.initTotp(content, () => {
          this.onLoginSuccess();
        });
        break;
      case "modules\\site\\auth\\EmailOtp":
        this.security.initEmailOtp(content, () => {
          this.onLoginSuccess();
        });
        break;
      case "craft\\auth\\methods\\RecoveryCodes":
        this.security.initRecoveryCodes(content, () => {
          this.onLoginSuccess();
        });
        break;
      default:
        throw new Error("Unknown authentication method: " + data.authMethod);
    }
    this.replaceOtherMethods(data.otherMethods);
    this.twoFaModal.open();
  }

  replaceOtherMethods(otherMethods) {
    const field = this.twoFaModal.content.querySelector(".other-2fa-methods");
    const select = field.querySelector("select");
    if (otherMethods && otherMethods.length > 0) {
      select.querySelectorAll("option").forEach((option) => option.remove());
      let option = document.createElement("option");
      option.value = "";
      option.innerHTML = "Select another method";
      select.appendChild(option);
      for (let method of otherMethods) {
        let option = document.createElement("option");
        option.value = method.class;
        option.innerHTML = method.name;
        select.appendChild(option);
      }
      field.classList.remove("hidden");
    } else {
      field.classList.add("hidden");
    }
  }

  initSelectOtherMethod() {
    const select = this.twoFaModal.content.querySelector(".other-2fa-methods select");
    select.addEventListener("change", (event) => {
      this.loader.classList.remove("hidden");
      const selectedMethod = event.currentTarget.value;
      this.fetchMethodForm(selectedMethod)
        .then((data) => {
          this.init2FaForm(data.data);
          this.loader.classList.add("hidden");
        })
        .catch(() => {
          this.loader.classList.add("hidden");
          App.toasts.create({
            message: "An error occurred",
            type: "error",
          });
        });
    });
  }

  fetchMethodForm(method) {
    const data = { method };
    data[App.settings.csrfTokenName] = App.settings.csrfToken;
    return axios.post("/?action=users/auth-form", data, {
      headers: {
        Accept: "application/json",
      },
    });
  }
}
